// 숫자 포맷 유틸 — 바닐라 dcf.js 의 fmt/pct/todayStr/fmtInput/numV 이식.
// 출력 문자열이 기존 화면과 동일해야 시각 패리티가 유지된다.

/** 백만원·주식수 등 정수 표기: 1234567 → "1,234,568", null/NaN → "—" */
export function fmt(n: number | null | undefined): string {
  return n === null || n === undefined || isNaN(n)
    ? "—"
    : Math.round(n).toLocaleString("ko-KR");
}

/** 비율 표기: 0.115 → "11.5%", null/NaN → "—" */
export function pct(x: number | null | undefined): string {
  return x === null || x === undefined || isNaN(x)
    ? "—"
    : (x * 100).toFixed(1) + "%";
}

/** YYYY-MM-DD (바닐라 todayStr) */
export function todayStr(): string {
  return new Date().toISOString().slice(0, 10);
}

/** 입력칸 초기값용 천단위 콤마 (바닐라 fmtInput) — 빈값은 "" */
export function fmtInput(v: number | string | null | undefined): string {
  if (v == null || v === "") return "";
  const n = Number(v);
  return isNaN(n) ? String(v) : Math.round(n).toLocaleString("ko-KR");
}

/** 콤마 섞인 입력 문자열 → 숫자 (바닐라 numV) — 실패 시 0 */
export function parseNum(s: string | null | undefined): number {
  return parseFloat(String(s ?? "0").replace(/,/g, "")) || 0;
}
